import { CommonAPIService } from '@/servicehandlers/CommonHandler';

export class DeviceRegistrationAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getUnregisteredUsers(router, store) {
    const url = `/api/devices/getunregistered`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postUserRegistration(data, router, store) {
    const url = `/api/devices/createregistration`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  getAssignableDevices(router, store) {
    const url = `/api/available_devices`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }
  checkDeviceStatus(serial_number, router, store) {
    const url = `/api/devices/check_device_status`;
    return this.CommonAPIService.postCall(url, { serial_number }, router, store);
  }
}
export default DeviceRegistrationAPIService;

